/* eslint-disable */
// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import { STORAGE_KEY } from '../constants'
import CryptoJS from 'crypto-js'
import Resizer from 'react-image-file-resizer'
import { toast } from 'react-toastify'
import visa from '../assets/img/visa_img.png'
import master from '../assets/img/master_card.png'
import discover from '../assets/img/discover_card.png'
import diner from '../assets/img/diners_card.png'
import amex from '../assets/img/amax_card.png'
import jcb from '../assets/img/jcb_hr.png'
import gpl from '../assets/img/gpl_hr.svg'
import apl from '../assets/img/apl_hr.svg'
import blank from '../assets/img/blank_credit_card.png'
import masterimg from '../assets/img/master_img.png'
import parkingpayments from '../assets/img/parkingpayments.png'
import townsend from '../assets/img/townsend.png'
import jordanImage from '../assets/img/intrapark_blue1bg.png'
import logos from '../assets/img/logos.svg'
import moment from 'moment-timezone'
import { errorMessage } from '../constants/errorMessage'
import { validPassword } from '../constants/globalConstants'

export const getBearerToken = () => localStorage.getItem(STORAGE_KEY.ID_TOKEN)

export const restrictInputValues = (event) => {
  if (!`${event.target.value}${event.key}`.match(/^[0-9]{0,6}$/)) {
    // block the input if result does not match
    event.preventDefault()
    event.stopPropagation()
    return false
  }
}

export const validateEmail = (email) => {
  // eslint-disable-next-line no-useless-escape
  const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
  return pattern.test(email)
}

export function isLoggedIn() {
  const userDataFromStorage = localStorage.getItem('sign_in') ? localStorage.getItem('sign_in') : '{}'
  const userData = JSON.parse(userDataFromStorage)
  const access_token = userData?.access_token
  if (access_token && access_token != '') {
    return true
  } else {
    return false
  }
}

export function loggedInUserData() {
  const userData = JSON.parse(localStorage.getItem('sign_in') ? localStorage.getItem('sign_in') : localStorage.getItem('sign_up') ? localStorage.getItem('sign_up') : '{}')
  return userData
}

export const restrictSpecialChar = (e) => {
  const result = (e.key == '!' || e.key == '@' || e.key == '#' || e.key == '$' || e.key == '%' || e.key == '^'
    || e.key == '&' || e.key == '~' || e.key == '`' || e.key == '*' || e.key == '(' || e.key == ')' || e.key == '_'
    || e.key == '=' || e.key == '+' || e.key == '[' || e.key == ']' || e.key == '{' || e.key == '}' || e.keyCode == 220
    || e.key == '|' || e.key == ':' || e.key == ';' || e.keyCode == 222 || e.key == ' ' || e.key == '?' || e.key == '.' || e.key == ',' || e.key == '>' || e.key == '<')
  if (result) {
    e.preventDefault()
  } else {
    return result
  }
}

export const fileChangedHandler = (event, fileId, setUpdateFileState, fileWidth, fileHeight) => {
  let fileInput = false
  let file = document.getElementById(fileId).files[0]
  fileInput = file && (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif')
  if (fileInput) {
    try {
      Resizer.imageFileResizer(
        file,
        fileWidth,
        fileHeight,
        'PNG', // fileType(JPEG, PNG,WEBP)
        100,  // quality compression(for jpeg)
        0, // rotation(0-100)
        (uri) => {
          new Promise((resolve, reject) => {
            const img = new Image()
            // the following handler will fire after a successful loading of the image
            img.onload = () => {
              const { naturalWidth: width, naturalHeight: height } = img
              resolve({ width, height })
              setUpdateFileState({ [fileId]: uri })
            }
            // and this handler will fire if there was an error with the image (like if it's not really an image or a corrupted one)
            img.onerror = () => {
              reject('There was some problem with the image.')
            }
            img.src = URL.createObjectURL(uri)
          })
        },
        'file' // outputType( base64, blob or file)
      )
    } catch (err) {
      setUpdateFileState({ fileId: '' })
    }
  } else {
    setUpdateFileState({ fileId: '' })
  }
}

export const passwordValidation = (value) => {
  return /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/i.test(value)
}

export const emailValidation = (value) => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
}

export const newpasswordValidation = (value) => {
  return /\b(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#(){}$!%*?&])[A-Za-z\d@$!%*?&]{8,15}\b/i.test(value)
}

export const encryptionHandler = (d) => {
  var nonceString = d.name_on_card + ':' + d.card_number + ':' + d.expiration_date + ':' + d.security_code + ':' + d.zip_code
  var CryptoJSAesJson = {
    stringify: function (cipherParams) {
      var j = {
        ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
        iv: '',
        s: ''
      }
      if (cipherParams.iv)
        j.iv = cipherParams.iv.toString()
      if (cipherParams.salt)
        j.s = cipherParams.salt.toString()
      return JSON.stringify(j)
    },
    parse: function (jsonStr) {
      var j = JSON.parse(jsonStr)
      var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) })
      if (j.iv)
        cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
      if (j.s)
        cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
      return cipherParams
    }
  }
  var encrypted = CryptoJS.AES.encrypt(JSON.stringify(nonceString), 'Tw5qNOJLe5GFe7rjFsentNNQBsRHstbNzTP/18lkjnY=', { format: CryptoJSAesJson }).toString()
  return encrypted
}


// to identifiy the type of the licence number

export const IdentifyLicenseNumber = (licenseNumber) => {
  const license_number = licenseNumber?.toUpperCase()
  if (license_number?.length === 9) {
    const alpha = license_number?.slice(0, 1)
    const number = license_number?.slice(1, 9)
    if (/^[a-zA-Z]+$/.test(alpha) && !/^[a-zA-Z]+$/.test(number)) {
      return 'Resident'
    } else {
      return 'Non-resident'
    }
  } else if (license_number !== '' && license_number?.length >= 7) {
    return 'Non-resident'
  } else {
    return ''
  }
}

export const notify = (type, message, toastId = null) => {
  if (type === 'error') {
    if (toastId) {
      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
        toastId: toastId
      })
    } else {
      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT
      })
    }
  } else if (type === 'success') {
    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT
    })
  }
}

export const phoneMasker = (phone) => {

  if (phone && phone.length >= 10) {
    let strlen = phone.length
    let start = strlen - 10
    let result = phone.slice(start, strlen)
    var USNumber = result.match(/(\d{3})(\d{3})(\d{4})/)
    return USNumber = '(' + USNumber[1] + ') ' + USNumber[2] + '-' + USNumber[3]
  } else {
    return '-'
  }

}
export const messageExtendSuccessPayment = 'Thank you for Parking with Us. Your Parking has been extended and ticket is sent to the registered Mobile Number.'
// export const messageSuccessPayment = 'Thank you for Parking with Us. Your e-Ticket details has been sent to the registered Mobile Number.' change as per docs shared by tripti mam
export const messageSuccessPayment = 'Thank you for Parking with Us. Your e-ticket has been sent to your mobile number; if entered.'
export const errorMessagePaymentFailed = 'Something went wrong. Please check your network connection and try again in some time. If your card is already charged, then please contact our support team.'

export const TimeConversion = (timeDuration) => {
  const daystoHoursTotal = timeDuration?.days && timeDuration?.days.length == 0 ? timeDuration?.days[0] : timeDuration?.days
  const hoursTotal = timeDuration?.hours && timeDuration?.hours.length >= 0 ? timeDuration?.hours[0] : timeDuration?.hours
  const minutesTotal = timeDuration?.minutes && timeDuration?.minutes.length >= 0 ? timeDuration?.minutes[0] : timeDuration?.minutes < 10 ? '0' + timeDuration?.minutes : timeDuration?.minutes
  const daystoHours = Number(daystoHoursTotal) * 24
  const totalHour = Number(daystoHours) + Number(hoursTotal)
  let totalHours = Number(totalHour + '.' + minutesTotal)

  return totalHours ? totalHours : 0
}
//old function minutes
// export const TimeConversion = (timeDuration) => {
//   const daystoHours = Number(timeDuration?.days) * 24
//   const minutestoHours = Number(timeDuration?.minutes) / 60
//   const totalHours = Number(daystoHours) + Number(timeDuration?.hours) + Number(minutestoHours)
//   return totalHours ? totalHours : 0
// }

export const getFieldValue = (name, e) => {
  return { target: { name: name, value: e } }
}

export const getLocation = (faciltyData) => {
  const location = faciltyData?.geolocations
  return `https://www.google.com/maps?daddr=${location?.latitude},${location?.longitude}+(${faciltyData?.full_name?.replace(/ /g, '+')})`
}


export const getMobileOS = () => {
  const ua = navigator.userAgent
  if (/android/i.test(ua)) {
    return 'Android'
  }
  else if ((/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return 'iOS'
  }
  return 'Other'
}

export const getCardIcon = (type) => {

  const cardType = type?.toLowerCase()

  switch (cardType) {
    case 'visa':
      return visa
    case 'vs':
      return visa
    case 'mastercard':
      return master
    case 'mastercardpng':
      return masterimg
    case 'mc':
      return master
    case 'm/c':
      return master
    case 'discover':
      return discover
    case 'dinersclub':
      return diner
    case 'americanexpress':
      return amex
    case 'amex':
      return amex
    case 'jcb':
      return jcb
    case 'gpay':
      return gpl
    case 'apl':
      return apl
    default:
      return blank
  }
}


export const getPartnerLogo = (name) => {

  const patnerName = name?.toLowerCase()
  switch (patnerName) {

    case 'parkingpayments':
      return parkingpayments
    case 'townsend':
      return townsend
    case 'demoparkengage':
      return logos
    case 'intrapark':
      return jordanImage

    default:
      return logos
  }
}

export const getPartnerTagline = (name) => {

  const patnerName = name?.toLowerCase()
  switch (patnerName) {

    case 'parkingpayments':
      return 'Parking Payments'
    case 'townsend':
      return 'PCI Townsend Parking'
    case 'demoparkengage':
      return 'Parkengage Parking'
    case 'intrapark':
      return 'IntraPark Parking'
    default:
      return 'Parkengage Parking'
  }
}

export const isSessionNotActive = (days, hours, minutes, seconds) => {
  if (days == '00' && hours == '00' && minutes == '00' && seconds == '00') {
    return false
  } else {
    return true
  }
}

export const getBreakUpDetails = (paymentData) => {
  let listItem = []
  let newParkingAmount = safeNumber(paymentData?.net_parking_amount, true) ?? undefined
  if (paymentData?.parking_amount && (paymentData?.parking_amount != '0.00' || paymentData?.is_price_applicable == '1')) {
    listItem = [...listItem, { 'headerName': 'Parking Amount', 'val': `$${paymentData?.parking_amount ? Number(paymentData?.parking_amount).toFixed(2) : '0.00'}` }]
  }

  if ((paymentData?.discount_hours && paymentData?.discount_hours != '') || (paymentData?.discount_amount && paymentData?.discount_amount != '' && (Number(paymentData?.discount_amount) > 0)) || ((paymentData?.promocode_discount_hours && paymentData?.promocode_discount_hours != '') || (paymentData?.promocode_discount_amount && paymentData?.promocode_discount_amount != '' && (Number(paymentData?.promocode_discount_amount) > 0)))) {
    let dataString = paymentData?.discount_hours ?
      `${Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.day ? getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.day : 0) > 1 ? Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.day) + ' Days ' : Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.day ? getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.day : 0) > 0 ? Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.day) + ' Day ' : ''}
    ${Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.hour ? getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.hour : 0) > 1 ? Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.hour) + ' Hrs ' : Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.hour ? getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.hour : 0) > 0 ? Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.hour) + ' Hr ' : ''}
    ${Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.minute ? getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.minute : 0) > 1 ? Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.minute) + 'Mins' : Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.minute ? getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.minute : 0) > 0 ? Number(getHoursIndayFormat(Number(paymentData?.discount_hours).toFixed(2), false)?.minute) + ' Min ' : ''}` :
      `${Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.day ? getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.day : 0) > 1 ? Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.day) + ' Days ' : Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.day ? getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.day : 0) > 0 ? Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.day) + ' Day ' : ''}
    ${Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.hour ? getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.hour : 0) > 1 ? Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.hour) + ' Hrs ' : Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.hour ? getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.hour : 0) > 0 ? Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.hour) + ' Hr ' : ''}
    ${Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.minute ? getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.minute : 0) > 1 ? Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.minute) + ' Mins ' : Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.minute ? getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.minute : 0) > 0 ? Number(getHoursIndayFormat(Number(paymentData?.promocode_discount_hours).toFixed(2), false)?.minute) + ' Min ' : ''}`

    listItem = [...listItem, {
      'headerName': (paymentData?.discount_hours || paymentData?.promocode_discount_hours) ? `Validated Amount (${dataString} Free)` : 'Discount Amount',
      'val': (paymentData?.discount_amount && Number(paymentData?.discount_amount) > 0) ? `(-) $${Number(paymentData?.discount_amount)?.toFixed(2)}` : (paymentData?.promocode_discount_amount && Number(paymentData?.promocode_discount_amount) > 0) ? `(-) $${Number(paymentData?.promocode_discount_amount)?.toFixed(2)}` : '$0.00'
    }]
  }

  if ((paymentData?.paid_amount && paymentData?.paid_amount !== '' && (Number(paymentData?.paid_amount) > 0))) {
    let dataString = (paymentData?.paid_hour && Number(paymentData?.paid_hour) > 0) ?
      `${Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.day ? getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.day : 0) > 1 ? Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.day) + ' Days ' : Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.day ? getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.day : 0) > 0 ? Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.day) + ' Day ' : ''}
    ${Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.hour ? getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.hour : 0) > 1 ? Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.hour) + ' Hrs ' : Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.hour ? getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.hour : 0) > 0 ? Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.hour) + ' Hr ' : ''}
    ${Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.minute ? getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.minute : 0) > 1 ? Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.minute) + 'Mins' : Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.minute ? getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.minute : 0) > 0 ? Number(getHoursIndayFormat(Number(paymentData?.paid_hour).toFixed(2), false)?.minute) + ' Min ' : ''}`
      : null

    listItem = [...listItem, {
      'headerName': dataString ? `Validated Amount (${paymentData?.business_policy && paymentData?.business_policy?.policy_name ? paymentData?.business_policy?.policy_name : '-'} - ${dataString} Free)` : `Validated Amount (${paymentData?.business_policy && paymentData?.business_policy?.policy_name ? paymentData?.business_policy?.policy_name : '-'})`,
      'val': paymentData?.paid_amount && Number(paymentData?.paid_amount) > 0 ? `(-) $${Number(paymentData?.paid_amount)?.toFixed(2)}` : '$0.00'
    }]
  }
  if ((newParkingAmount && (Number(newParkingAmount) < Number(paymentData?.parking_amount)))) {
    listItem = [...listItem, { 'headerName': 'Net Parking Amount', 'val': `$${newParkingAmount ? Number(newParkingAmount).toFixed(2) : '0.00'}` }]
  }

  // if ((((paymentData?.CCFee && paymentData?.CCFee != '0.00') || (paymentData?.processing_fee && paymentData?.processing_fee != '0.00')) && (paymentData?.is_overstay != 1 || paymentData?.is_extended != 1)) || paymentData?.is_price_applicable == '1') {
  //   listItem = [...listItem, { 'headerName': 'Processing Fee', 'val': `$${paymentData?.processing_fee ? paymentData?.CCFee ? Number(Number(paymentData?.CCFee) + Number(paymentData?.processing_fee))?.toFixed(2) : Number(paymentData?.processing_fee).toFixed(2) : '0.00'}` }]
  // }

  if ((((paymentData?.CCFee && paymentData?.CCFee != '0.00') || (paymentData?.processing_fee && paymentData?.processing_fee != '0.00')) && (paymentData?.is_overstay != 1 || paymentData?.is_extended != 1 || (paymentData?.CCFee && paymentData?.CCFee != '0.00'))) || (paymentData?.processing_fee && paymentData?.is_price_applicable == '1')) {
    let processingFee = paymentData?.processing_fee ? paymentData?.processing_fee : '0.00'
    listItem = [...listItem, { 'headerName': 'Processing Fee', 'val': `$${processingFee ? paymentData?.CCFee ? Number(Number(paymentData?.CCFee) + Number(processingFee))?.toFixed(2) : Number(processingFee).toFixed(2) : '0.00'}` }]
  }

  if (paymentData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1' && ((paymentData?.surcharge_fee && paymentData?.surcharge_fee != '0.00') || paymentData?.is_price_applicable == '1')) {
    listItem = [...listItem, { 'headerName': 'City Surcharge', 'val': `$${paymentData?.surcharge_fee ? Number(paymentData?.surcharge_fee).toFixed(2) : '0.00'}` }]
  }

  if (((paymentData?.tax_rate && paymentData?.tax_rate != '0.00') || (paymentData?.tax_fee && paymentData?.tax_fee != '0.00')) || ((paymentData?.tax_rate || paymentData?.tax_fee) && paymentData?.is_price_applicable == '1')) {
    let taxAmount = paymentData?.tax_rate ? paymentData?.tax_rate : paymentData?.tax_fee ? paymentData?.tax_fee : '0.00'
    listItem = [...listItem, { 'headerName': 'Tax', 'val': `$${Number(taxAmount).toFixed(2)}` }]
  }

  if (paymentData?.extend_amount && paymentData?.extend_amount !== '' && ((paymentData?.extend_amount != '0.00' && Number(paymentData?.extend_amount) > 0))) {
    listItem = [...listItem, { 'headerName': 'Extended Amount', 'val': `$${paymentData?.extend_amount ? Number(paymentData?.extend_amount).toFixed(2) : 0}` }]
  }

  if ((paymentData?.parking_amount && paymentData?.parking_amount != '0.00') && (paymentData?.is_vehicle_oversize && paymentData?.is_vehicle_oversize == 1)) {
    listItem = [...listItem, { 'headerName': '(**Oversize Fee Applied)', 'val': '0', extraParam: '1' }]
  }

  return listItem

}

export const isPromoValidateButton = (facilityData, conditionArray, ticketDetails = null) => {
  // Check if is_promocode_validation_enabled's value is in the conditionArray
  const isPromocodeValidationEnabled = facilityData?.facility?.is_promocode_validation_enabled
  if (isPromocodeValidationEnabled !== undefined && conditionArray.includes(isPromocodeValidationEnabled)) {
    if (!ticketDetails) {
      return true
    } else if (((ticketDetails?.discount_amount == ticketDetails?.total) && (Number(ticketDetails?.payable_amount) === 0) || (ticketDetails?.promocode && ticketDetails?.discount_amount))) {
      return false
    } else {
      return true
    }
  } else {
    return false
  }
}

export const isExtendButton = (facilityData, conditionArray) => {
  // Check if is_extend_allow's value is in the conditionArray
  const isPromocodeValidationEnabled = facilityData?.is_extend_allow
  if (isPromocodeValidationEnabled !== undefined && conditionArray.includes(isPromocodeValidationEnabled)) {
    return true
  } else {
    return false
  }
}

export const priceGreaterOrNot = (ticketDetails) => {
  const paymentDataKeys = ['parking_amount', 'amount_paid', 'processing_fee', 'tax_rate', 'payable_amount', 'grand_total', 'discount_amount', 'paid_amount']
  let isGreaterOrNot = paymentDataKeys.map((key) => {
    if ((ticketDetails?.[key] && (Number(ticketDetails?.[key]) > 0 || ticketDetails?.is_price_applicable == '1'))) {
      return true
    } else {
      return false
    }
  })
  if (isGreaterOrNot.includes(true)) {
    return true
  } else {
    return false
  }
}


export const getHoursForRateBand = (data) => {
  return parseInt(data?.[0]?.max_stay)
}

export const getPartnerDetails = () => {
  if (localStorage.getItem('partnerData') == 'undefined' || localStorage.getItem('partnerData') == undefined) {
    localStorage.removeItem('partnerData')
    sessionStorage.removeItem('partnerData')
  }
  const partner = localStorage.getItem('partnerData') ? JSON.parse(localStorage.getItem('partnerData')) : sessionStorage.getItem('partnerData') ? JSON.parse(sessionStorage.getItem('partnerData')) : ''
  return partner
}

export function sortPortalPermissionByKey(partnerDetails, sectionName) {
  return partnerDetails?.customer_portal_permission?.[sectionName]?.map((item) => item)
}

export const isPermissionExist = (data, itemName) => {
  const filterObj = (data?.length > 0) && data?.filter((item) => item?.display_name == itemName)
  if (filterObj[0]?.is_default == '1') {
    return true
  } else {
    return false
  }
}

export const getFormattedTime = (totalhours, isConvert) => {

  const splittedTime = totalhours?.split('.')
  let minutes
  if (isConvert) {
    minutes = (splittedTime?.[1] / 100) * 60
  } else {
    minutes = splittedTime?.[1]
  }
  const hours = splittedTime ? `${splittedTime?.[0] == 0 ? '00' : splittedTime?.[0] == 0 ? '00' : Number(splittedTime?.[0]) < 10 ? `0${splittedTime?.[0]} ` : splittedTime?.[0]} : ${minutes != 0 ? minutes : '00'}` : ''
  return hours
}

export const getDeviceType = () => {
  // Find if the device is IOS or Android/General
  let userAgent = navigator.userAgent || navigator.vendor
  const deviceType = (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    ? true : false
  return deviceType
}

export const getConvertedDate = (date) => {
  const deviceType = getDeviceType()
  let date_final

  const dateNew = moment(date, 'YYYY-MM-DD HH:mm:ss').set('second', 0).add(10, 'seconds').format('YYYY-MM-DD HH:mm:ss')
  if (deviceType) {
    let arr = dateNew.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final = newDate
  } else {
    date_final = dateNew
  }
  return date_final
}

export const getErrorMessage = (response) => {
  let errorMsg = 'Sorry! something went wrong, please try again.'
  const errorsList = response.errors
  if (errorsList.message !== 'Validation Errors') {
    errorMsg = errorsList.message
  } else {
    for (const key in errorsList.detail) {
      if (Object.prototype.hasOwnProperty.call(errorsList.detail, key)) {
        if (typeof errorsList.detail === 'undefined') {
          errorMsg = errorsList.message
        } else {
          errorMsg = Array.isArray(errorsList.detail[key]) ? errorsList.detail[key][0] : errorsList.detail[key]
        }
      }
    }
  }

  return errorMsg
}
export const convertNumDouble = (timer) => {
  if (!Number(timer).isNaN && (Number(timer) < 10 && Number(timer) > 0)) {
    return '0' + timer
  } else {
    return timer
  }
}
export const convertTimeToDoubleDig = (time) => {
  let stringTime = time + ''
  if (stringTime.includes('.')) {
    let str = stringTime.split('.')
    if (Number(str[0]) < 9) {
      return '0' + str[0] + '.' + str[1]
    } else {
      return time
    }
  } else {
    return time
  }
}

export const getFacilityOpenDays = (data) => {
  let result
  const daysToCheck = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
  const MondayToFriday = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']
  const keysWithValueOne = daysToCheck.filter(day => data[day] == '1')
  if (keysWithValueOne?.length == 7) {
    result = 'All Days'
  } else if (areAllElementsPresent(MondayToFriday, keysWithValueOne)) {
    result = 'Monday-Friday'
  } else if (keysWithValueOne?.length > 0) {
    result = keysWithValueOne?.map((item, index) => {
      if (index != (keysWithValueOne?.length - 1)) {
        return nameUpperCase(item) + ', '
      } else {
        return nameUpperCase(item)
      }
    })
  } else {
    result = null
  }
  return result
}

export const areAllElementsPresent = (arr1, arr2) => {
  return arr1.every(function (element) {
    return arr2.includes(element)
  })
}

export const nameUpperCase = (nameString) => {
  const arr = nameString.split('_')
  for (var i = 0; i < arr.length; i++) { arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1) }
  let finalName = arr.join(' ')
  return finalName
}

export const TimeConversionInHours = (timeDuration) => {
  const hours = Math.floor(timeDuration / 60)
  const minutes = timeDuration % 60
  return `${Number(hours) < 10 ? '0' + hours : hours}.${Number(minutes) < 10 ? '0' + minutes : minutes}`
}

export const timeValidationConversion = (facility) => {
  if (facility?.is_price_band == '1' && facility?.is_custom_picker_enabled == '1') {
    return errorMessage.validDurationRateBand
  } else if (facility?.is_price_band == '1') {
    return errorMessage.validRateBand
  }
  return errorMessage.validDuration
}

export const encryptedFacilityKey = (facilityid, gateid = 11) => {
  const facilityObject = JSON.stringify({ "facility_id": facilityid, "gate": gateid })
  const stringToEncode = facilityObject
  const encodedString = btoa(stringToEncode)
  return encodedString
}

export const getDiffFromTwoTime = (endTime, screen) => {
  let facilityTimeZone = 'America/New_York'
  if (screen == 'extend') {
    const data = JSON?.parse(localStorage?.getItem('ExtendData'))
    facilityTimeZone = data?.facility?.timezone || 'America/New_York'
  } else {
    const data = JSON.parse(localStorage?.getItem('paymentRecipt'))
    facilityTimeZone = data?.facility?.timezone || 'America/New_York'
  }
  let now = moment(new Date()).tz(facilityTimeZone).format('YYYY-MM-DD HH:mm:ss')
  const timeDiff = moment(endTime).diff(now, 'minutes')
  return timeDiff
}

export const validExpiryDate = (value) => {
  let expiryDateCheck = value.length == 4 && value.substring(0, 2) < 13 && (value.substring(0, 2) >= moment(new Date()).format('MM') && value.substring(2) >= moment(new Date()).format('YY')
    || value.substring(0, 2) <= moment(new Date()).format('MM') && value.substring(2) > moment(new Date()).format('YY')
  )
  return expiryDateCheck
}

export const formattedExpiry = (expiry) => {
  return expiry.slice(0, 2) + '/' + expiry.slice(2)
}

export const restrictInValidCharPassword = (value = '') => {
  // List of restricted characters
  const restrictedChars = /[^!@#$%^&*?\w\s-]/g

  // Remove restricted characters from the input value
  let filteredValue = value?.replace(restrictedChars, '')
  filteredValue = filteredValue?.replace('_', '')
  filteredValue = filteredValue?.replace(' ', '')

  // Restrict the length to a maximum of 15 characters
  if (filteredValue?.length > 15) {
    filteredValue = filteredValue?.substring(0, 15);
  }
  return filteredValue
}

export const restrictInValidCharLicense = (value = '') => {
  const restrictedChars = /[^a-zA-Z0-9]/g

  // Remove restricted characters from the input value
  let filteredValue = value?.replace(restrictedChars, '')
  filteredValue = filteredValue?.replace('_', '')
  filteredValue = filteredValue?.replace(' ', '')
  return filteredValue
}

export const validatePassword = (pwd) => {
  // eslint-disable-next-line no-useless-escape
  return validPassword.test(pwd)
}

export const getFirstErrorMessage = (priorityFields, errors) => {
  for (let field of priorityFields) {
    if (errors[field]) {
      return errors[field].message;
    }
  }
  return null;
};

export const checkExpired = (dt) => {
  let yr = dt?.slice(-2)
  let mt = dt?.slice(0, 2)
  // console.log(yr, mt)
  const inputDate = moment('20' + yr + '-' + mt + '-15', 'YYYY-MM-DD')
  const currentDate = moment()
  // Compare year first
  if (inputDate.year() > currentDate.year()) {
    return false
  } else if (inputDate.year() < currentDate.year()) {
    return true
  } else {
    return inputDate.month() < currentDate.month()
  }
}


export const decryptionHandler = (encryptedData) => {

  encryptedData = JSON.parse(encryptedData);
  var ciphertext = CryptoJS.enc.Base64.parse(encryptedData.ct);
  var iv = CryptoJS.enc.Base64.parse(encryptedData.iv);
  var key = CryptoJS.enc.Utf8.parse('wqojwrgw1BX5cNGAtEzG3MA5BAmbMRcx');
  var decryptedWA = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, key, { iv: iv });
  var plaintext = decryptedWA.toString(CryptoJS.enc.Utf8);
  // var encrypted = CryptoJS.AES.encrypt(JSON.stringify(encryptedData), 'Tw5qNOJLe5GFe7rjFsentNNQBsRHstbNzTP/18lkjnY=', { format: CryptoJSAesJson }).toString()
  return JSON.parse(plaintext)
}
export const getFormattedAmount = (value) => {
  const amount = value ? Number(value?.toString()?.replace(/,/g, ''))?.toFixed(2) : '0.00'
  return amount
}

export const handleKeyPressRestrictLeadingTrailingSpace = (e, restrictAllSpace = false) => {
  const value = e.target.value
  const char = e.key
  if (restrictAllSpace && (char === ' ')) {
    e.preventDefault()
  } else {
    // Prevent space if there is no character yet (i.e., first input is space)
    if (char === ' ' && value.trim() === '') {
      e.preventDefault()
    }

    // Prevent multiple consecutive spaces
    if (char === ' ' && value[value.length - 1] === ' ') {
      e.preventDefault()
    }
  }
}
export const getHoursIndayFormat = (hrs, split = false) => {
  let getMin = split ? hrs?.split(':') : hrs?.split('.')
  if (getMin?.length > 0) {
    let days = Math.floor(Number(getMin.join('.')) / 24)
    let remainingHours = Math.floor(Number(getMin.join('.')) % 24)
    let minutes = Number(getMin[1])

    let duration = moment.duration({ hours: remainingHours, minutes: minutes })
    return {
      day: days,
      hour: duration.hours(),
      minute: duration.minutes()
    }
  } else {
    return null
  }

}

export const isValidPromoCode = (text, isRedirect) => {
  // Regular expression to detect URLs
  const urlPattern = /(https?:\/\/|www\.)[^\s]+/i

  // Check if the text contains a URL
  if (urlPattern.test(text)) {
    if (!isRedirect) {
      // window.location.href = text
    }
    return false
  }

  // Additional checks for promo code validity (optional)
  const promoCodePattern = /^[A-Z0-9]{5,}$/ // Example: Promo codes with 5+ alphanumeric characters
  return promoCodePattern.test(text)
}
export const checkEstimateTime = (facilityData, ticketDetails) => {
  if (ticketDetails?.estimated_checkout) {
    const curTime = moment().tz(facilityData?.facility?.timezone ? facilityData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')
    const estimated_checkoutTime = moment(ticketDetails?.estimated_checkout).format('YYYY-MM-DD HH:mm:ss')
    return moment(curTime).isBefore(moment(estimated_checkoutTime), 'minute')
  } else {
    return true
  }
  // console.log(curTime.format('YYYY-MM-DD hh:mm:ss A'), curTime.isBefore(estimated_checkoutTime), estimated_checkoutTime, 'I am here 1')

}
export const ratebandsRefresh = (ticket = null, responsData = '{}', is_refresh_disabled = false) => {
  const data = JSON.parse(responsData)
  if (ticket) {
    const currentTime = new Date(getConvertedDate(moment(new Date()).tz(ticket?.facility?.timezone ? ticket?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
    const checkinTime = new Date(getConvertedDate(moment(new Date(ticket?.checkin_time)).format('YYYY-MM-DD HH:mm:ss')))
    const totalHours = moment(currentTime).diff(checkinTime, 'minutes')
    const timeRemain = TimeConversionInHours(totalHours)
    let correctRates = is_refresh_disabled ? data?.price_band : data?.price_band.filter((item) => {
      if (Number(item.max_stay) > Number(timeRemain)) {
        return true
      }
      return false
    })
    return correctRates
  } else {
    return []
  }
}

export const parseCurrency = (value) => {
  if (!value) return 0;
  return Number(value.replace('$', ''));
};

export function isOnlyHTML(str) {
  const htmlOnlyRegex = /^(?:\s*<[^>]+>\s*)+$/;
  return htmlOnlyRegex.test(str);
}

export const getRootDomain = () => {
  const url = window.location.toString()
  const hostname = new URL(url).hostname
  // Split the hostname into parts
  const parts = hostname.split('.')

  // Handle localhost or simple domains
  if (parts.length <= 2) return hostname

  // Common TLD handling (like .co.uk, .com.au, etc.)
  const knownSecondLevelTLDs = ['co.uk', 'org.uk', 'gov.uk', 'ac.uk', 'com.au', 'net.au']

  const lastTwo = parts.slice(-2).join('.')
  // const lastThree = parts.slice(-3).join('.')

  if (knownSecondLevelTLDs.includes(lastTwo)) {
    return parts.slice(-3).join('.')
  }

  return lastTwo
}

export const getPartnerSpecificUrl = (server) => {

  const rootDomain = getRootDomain()
  return `${server}.${rootDomain}`
  // switch (portal) {
  //   case 'admin':

  //     break;
  //   case 'transient':
  //     break;
  //   case 'receipt':
  //     break;
  //   case 'checkin':
  //     break;
  //   case 'customerportal':
  //     break;
  //   case 'autovalidate':
  //     break;
  //   case 'events':
  //     break;
  //   case 'reservation':
  //     break;
  //   case 'citation':
  //     break;

  //   default:
  //     break;
  // }

}


export const getbase64EncodedString = (string) => {
  const obj = { facility_id: string, gate: 11 };
  const jsonString = JSON.stringify(obj);
  const base64 = btoa(jsonString);
  return base64
}


export const isBase64 = (str) => {
  try {
    if (!/^[A-Za-z0-9+/]+={0,2}$/.test(str) || str.length % 4 !== 0) {
      return false
    }

    const binary = atob(str)
    const utf8 = new TextDecoder().decode(
      new Uint8Array([...binary].map(c => c.charCodeAt(0)))
    )
    const reEncoded = btoa(
      new TextEncoder().encode(utf8).reduce((data, byte) => data + String.fromCharCode(byte), '')
    )

    return str.replace(/=+$/, '') === reEncoded.replace(/=+$/, '')
  } catch (e) {
    return false
  }
}

export const isVehicleLimitExceeded = (accessPermissions = [], getVehicleList = [], vehicleLimit = 0) => {
  let isLimitExceeded = false
  const vehicleLimitEnabled = isPermissionExist(accessPermissions, 'Enable Vehicle Limit')
  const currentTotalVehicles = getVehicleList?.length

  if (vehicleLimitEnabled && vehicleLimit > 0 && currentTotalVehicles >= vehicleLimit) {
    isLimitExceeded = true
  }
  return isLimitExceeded
}

// Function to check if the HTML is generating any visible Content or just Blank Tags
export function isHtmlRenderingVisibleContent(htmlString) {
  // Create a hidden container
  const container = document.createElement('div');
  container.style.position = 'absolute';
  container.style.left = '-9999px';
  container.style.top = '-9999px';
  container.style.visibility = 'hidden';

  // Inject the HTML
  container.innerHTML = htmlString;
  document.body.appendChild(container);

  // Check if any visible content is rendered
  const hasVisibleText = container.textContent.trim().length > 0;
  const hasRenderedDimensions = container.getBoundingClientRect().height > 0 &&
    container.getBoundingClientRect().width > 0;

  // Cleanup
  document.body.removeChild(container);

  return hasVisibleText || hasRenderedDimensions;
}

export const showhideWalletButton = (facility) => {
  const device = getDeviceType()
  if (device && facility?.facility_configuration?.show_apple_pay_button == '1' && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'development') && window.location.protocol === 'https:') {
    return true
  } else if (!device && facility?.facility_configuration?.show_google_pay_button == '1' && ((process.env.NODE_ENV === 'production' && window.location.protocol === 'https:') || process.env.NODE_ENV === 'development')) {
    return true
  } else {
    return false
  }
}

export const formatExpiryDate = (str) => {
  if (str && str.length) {  // Ensure 'str' is defined and not empty
    const year = str.slice(0, 4);
    let month = str.slice(4);  // Use 'let' here to allow reassignment
    if (parseInt(month) < 10) {
      month = `0${month}`; // Add leading zero if the month is less than 10
    }
    return `${month}${year.slice(2)}`; // Output month first, year last (last 2 digits)
  }
  return 'Invalid input'; // Handle empty or invalid strings
};

export const isIPAddress = (hostname) => {
  // IPv4 pattern (e.g., 192.168.1.1)
  const ipv4Pattern = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

  // IPv6 pattern (basic check)
  const ipv6Pattern = /^(([0-9a-fA-F]{1,4}):){7}([0-9a-fA-F]{1,4})$/;

  return ipv4Pattern.test(hostname) || ipv6Pattern.test(hostname);
}

export const isMaxDays = (facility, ticketDetails, activeduration = false, duration = 0, activeDate = false, date = '', startDate) => {
  // console.log(facility, 'Check if facility is enabled for maximum days')
  const featureEnabled = ((facility?.facility_configuration?.is_restricted_days == '1' && Number(facility?.facility_configuration?.restricted_days) > 0) || (ticketDetails?.facility?.facility_configuration?.is_restricted_days == '1' && Number(ticketDetails?.facility?.facility_configuration?.restricted_days) > 0)) ? true : false
  const dynamicDate = ticketDetails?.facility?.facility_configuration?.restricted_days ? Number(ticketDetails?.facility?.facility_configuration?.restricted_days) : Number(facility?.facility_configuration?.restricted_days)
  const dynamicMinutes = ((Number(dynamicDate) * 24) * 60) + 1 // added 1 minute grace due to the issue with seconds mismatch
  const dynamicDuration = (Number(duration) * 24) * 60
  let ticketTime = 0
  const toastId = "max-days-error";
  if (ticketDetails?.checkin_time && ticketDetails?.checkout_datetime) {
    let checkinTime = moment(ticketDetails?.checkin_time, 'YYYY-MM-DD HH:mm:ss').set({ second: 10 })
    let checkoutTime = moment(ticketDetails?.checkout_time, 'YYYY-MM-DD HH:mm:ss').set({ second: 10 })
    ticketTime = moment.duration(checkoutTime.diff(checkinTime)).asMinutes()
  }
  const maxDay = dynamicMinutes - ticketTime
  if (featureEnabled && activeduration) {
    if (dynamicDuration <= maxDay) {
      return true
    } else {
      notify('error', `Please purchase a permit for bookings longer than ${dynamicDate} days.`, toastId)
      return false
    }
  } else if (featureEnabled && activeDate) {
    const curDate = ticketDetails?.checkout_datetime ? moment(ticketDetails?.checkout_datetime, 'YYYY-MM-DD HH:mm:ss') : startDate ? moment(startDate, 'MM/DD/YYYY hh:mm:ss A').set({ second: 10 }) : moment().tz(facility.timezone ? facility.timezone : 'America/New_York')
    const checkDate = moment(date, 'YYYY-MM-DD HH:mm:ss')
    const totalDate = moment.duration(checkDate.diff(curDate)).asMinutes()
    // console.log('I am here', totalDate, maxDay, ticketDetails?.checkout_datetime, date, ticketTime)
    if (totalDate <= maxDay) {
      return true
    } else {
      notify('error', `Please purchase a permit for bookings longer than ${dynamicDate} days.`, toastId)
      return false
    }
  } else {
    return true
  }
}

export const paybyCardorWallet = (ticketDetails = {}, payBy = 'card') => {
  if (payBy == 'card' && (ticketDetails?.payment_method != 'GPAY' && ticketDetails?.payment_method != 'APL')) {
    return true
  } else if (payBy == 'wallet' && ticketDetails?.payment_method && (ticketDetails?.payment_method == 'GPAY' || ticketDetails?.payment_method == 'APL')) {
    return true
  }
  return false
}

export const navigateToHomeScreen = (partner = '', navigate = null, setIsEndingParking = null) => {
  localStorage.removeItem('paymentRecipt')
  localStorage.removeItem('ExtendData')
  localStorage.removeItem('isCouponApplied')
  setTimeout(() => {
    const pushBack = JSON.parse(localStorage.getItem('history'))
    if (pushBack?.route && pushBack?.facility) {
      navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
    } else {
      navigate(`/${partner}`)
    }
    setIsEndingParking(false)
  }, 3000)
}

export const safeNumber = (input = '', asString = false, afterDecimal = 2) => {
  // If input is null, undefined, or empty string (except 0), return null
  if (
    input === null ||
    input === undefined ||
    (typeof input === 'string' && input.trim() === '') // allow "0"
  ) {
    return null;
  }

  // Allow numbers and numeric strings including "0"
  const cleaned = String(input).replace(/,/g, '').trim();
  const num = Number(cleaned);

  if (isNaN(num)) return null;

  const fixed = num.toFixed(afterDecimal);
  return asString ? fixed : Number(fixed);
};
